//
// # Orientation Matrices
//
// Rules for `Orientation`:
// - Reflection is vertical, i.e. about the x-axis
// - Rotation is counter-clockwise
// - Reflection is applied *before* rotation
//

//
// # Orientation Matrix
//
// 2x2 matrix representation of an `Orientation`
// Largely corresponds to the values placed in SVG `matrix` attributes.
// SVG matrices are ordered "column major", i.e. `matrix (a, b, c, d, x, y)` corresponds to
// | a c |
// | b d |
// The fields of `Matrix` are named similarly.
//
export interface Matrix {
  a: number;
  b: number;
  c: number;
  d: number;
}

// The "impl" of matrix-related functions
export const Matrix = {
  new: (a: number, b: number, c: number, d: number): Matrix => {
    return { a, b, c, d };
  },
  identity: (): Matrix => {
    return { a: 1, b: 0, c: 0, d: 1 };
  },
  eq(a: Matrix, b: Matrix): boolean {
    return a.a === b.a && a.b === b.b && a.c === b.c && a.d === b.d;
  },
};
